module.exports = __webpack_public_path__ + "img/answer.cb2e34cb.jpeg";